@import (reference) '../../constants/spacing.module.less';

.dropdown {
  box-shadow: 1px 1px 3px var(--dark--box-shadow-color--2);
  border-radius: 3px;
  border: 0.5px solid var(--default--dropdown--border-color--2);
  overflow: hidden;
  min-width: 260px;
}

.option {
  height: 56px;
  padding: 0;
  border-radius: 0;
  overflow: hidden;
  cursor: pointer;
  background-color: var(--light--list-item--background-color--1);
  border-bottom: 0.5px solid var(--default--dropdown--border-color--2);
  color: var(--default--text-color--4);
}

.option:last-child {
  border-bottom: none;
}

.option:hover {
  background-color: var(--primary--hover--background-color--3);
}

.option[data-combobox-active] {
  background-color: var(--primary--hover--background-color--3);
}

.option[data-combobox-disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

.option[data-combobox-disabled]:hover {
  background-color: var(--light--list-item--background-color--1);
}

.result-item {
  display: flex;
  flex-flow: row;
  gap: @space-8;
  align-items: center;
  height: 100%;
  padding: 0 @space-8;
  overflow: hidden;
}

.product-name {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  overflow: hidden;
  white-space: nowrap;
}

.product-sku {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: var(--table-cell--subtext--text-color);
  overflow: hidden;
  white-space: nowrap;
}

.disabled-reason {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: var(--error--text-color--1);
  overflow: hidden;
  white-space: nowrap;
  font-style: italic;
  margin-top: 2px;
}

.image-container {
  width: 40px;
  height: 40px;
  min-width: 40px;
  margin: 0;
  flex-shrink: 0;
}
